export default function KanbanIcon(props) {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16"{...props}>
      <path fill="#4C62FB" d="M4 4H0V0h4v4Zm6-4H6v4h4V0Zm6 0h-4v4h4V0ZM4 6H0v4h4V6Zm6 0H6v4h4V6Zm6 0h-4v4h4V6ZM4 12H0v4h4v-4Zm6 0H6v4h4v-4Zm6 0h-4v4h4v-4Z" />
    </svg>
  );
}
